import React from 'react';
import { Text, Linking, StyleProp, TextStyle } from 'react-native';
import { Device } from 'DeviceUtils';
import defaultStyles from './WebLink.jss';

type WebLinkProps = {
    url: string;
    text: string;
    style?: StyleProp<TextStyle>;
};

const WebLink = ({ url, text, style }: WebLinkProps): JSX.Element => (
    <Text
        onPress={() => Device.isPhone ? Linking.openURL(url) : window.open(url, '_blank')}
        style={[defaultStyles.container, style]}
    >
        {text}
    </Text>
);

export default WebLink;
